// Core
import React, { useEffect, useState } from "react";
//Import Scss
import "./styles.scss";
//Import assets
import assets from "../../../../Assets";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchSingleFailureAnalysisRequest } from "../../../../Redux/Slices/failureAnalysisReqSlice";

const LubricationDetails = (farId) => {
  const [lubricationDetails, setLubricationDetails] = useState({});
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    getIndividualData();
  }, []);

  const getIndividualData = () => {
    dispatch(
      fetchSingleFailureAnalysisRequest({
        data: {
          remote_failure_details_id: id || farId.farId,
        },
        callBack: getLubricationData,
      })
    );
  };

  const getLubricationData = (data) => {
    setLubricationDetails(data?.result?.remote_failure_lubrication_details);
  };

  return (
    <div className="LubricationDetailsContainer">
      <div className="LubricationDetailsHeader">
        <h2>Lubrication Details</h2>
      </div>
      <div className="LubricationDetailsBody">
        <div className="LubricationDetailRow">
          <div className="LubricationDetailRowLabel">Lubrication Type</div>
          <div className="">: {lubricationDetails?.lubrication_type_name}</div>
        </div>
        <div className="LubricationDetailRow">
          <div className="LubricationDetailRowLabel">Lubrication Method</div>
          <div className="">
            : {lubricationDetails?.lubrication_method_name}
          </div>
        </div>
        <div className="LubricationDetailRow">
          <div className="LubricationDetailRowLabel">Lubrication Sample</div>
          <div className="">: {lubricationDetails?.lubrication_sample_name}</div>
        </div>
        <div className="LubricationDetailRow">
          <div className="LubricationDetailRowLabel">Lubrication Condition</div>
          <div className="">: {lubricationDetails?.lubrication_condition}</div>
        </div>
        <div className="LubricationDetailRow">
          <div className="LubricationDetailRowLabel">
            Lubrication Make/Designation
          </div>
          <div className="">: {lubricationDetails?.lubrication_make}</div>
        </div>
        <div className="LubricationDetailRow">
          <div className="LubricationDetailRowLabel">
            Lubricant Has AW/EP Properties?
          </div>
          <div className="">
            : {lubricationDetails?.has_aw_or_ep_properties_name}
          </div>
        </div>
      </div>

      <div style={{ marginTop: "25px" }} className="LubricationDetailsHeader">
        <h2>Physical Inspection of Bearing</h2>
      </div>
      <div className="LubricationDetailsBody">
        <div className="LubricationDetailRow">
          <div className="LubricationDetailRowLabel">Inspection of Bearing</div>
          <div className="">
            : {lubricationDetails?.inspection_of_bearing_name}
          </div>
        </div>
        <div className="LubricationDetailRow">
          <div className="LubricationDetailRowLabel">Additional Details</div>
          <div className="">
            : {lubricationDetails?.additional_details}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LubricationDetails;
